import { css } from '@/styled-system/css';

export const contentContainerStyles = css.raw({
  minHeight: '550px',
  minWidth: '0',
  padding: { base: '{spacing.600} {spacing.400}', xl: '{spacing.800}', xxl: '{spacing.600}' },
  backgroundColor: 'bg.neutral',
  flex: '1',
  width: '100%',
  borderRadius: { xl: '100' },
  alignSelf: 'center',
  display: 'flex',
  flexDirection: 'column',

  '& .transition-wrapper': {
    height: '100%',
  },

  '@media (min-height: 900px)': {
    minHeight: '640px',
  },
  xxl: {
    maxWidth: '712px',
    minHeight: '610px',
  },
});

export const wideLayoutContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'bg.neutral',
  maxWidth: '1280px',
  minHeight: '550px',
  flex: '1',
});

export const bodyContainerStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  padding: { base: 0, lg: '600' },
});
